import React from 'react';
import { FLOWCHART_VISUAL_DOT_PITCH, FLOWCHART_DOT_GRID_BG } from '../constants';

const CanvasGrid = ({ gridBounds }) => (
  <div
    className="flowchart__canvas-grid"
    aria-hidden
    style={{
      left: gridBounds.minX,
      top: gridBounds.minY,
      width: gridBounds.width,
      height: gridBounds.height,
      backgroundImage: FLOWCHART_DOT_GRID_BG,
      backgroundSize: `${FLOWCHART_VISUAL_DOT_PITCH}px ${FLOWCHART_VISUAL_DOT_PITCH}px`,
    }}
  />
);

export default CanvasGrid;
